import axios from 'axios';

export const EXTENT_TYPE = {
    LISTING: 'LISTING',
    QUICKREPLY: 'QUICKREPLY'
};

// chime-chat 的各种服务
export default {
    /**
     *
     * @param {*} sessionInfo
     * sessionInfo.userId 为该站的 agentId
     * sessionInfo.sessionId 会话 Id 从 chatbox_visitor_session_id cookie 中提取
     * 有的话则存储该 cookie 无则不处理
     */
    async getVisitorToken(sessionInfo) {
        // 返回结果为 {data,status} 的格式
        let { data } = await axios.get(
            '/api/chatbot/ai/assistant/visitors/enable',
            {
                params: sessionInfo
            }
        );
        // TODO: 此处配置如何从数据库获取,若配置了 AI 模式则返回
        return data;
    },
    // 第三方 chatbox 触发登录逻辑
    async thirdPartySignLog(authData) {
        let res = await axios.post('/api-site/third-party/login', authData);
        let { data } = res;
        return data;
    },
    async thirdPartyRegister(registerData) {
        let res = await axios.post(
            '/api-site/third-party/register',
            registerData
        );
        let { data } = res;
        // TODO: 此处须确保注册成功
        return data;
    },
    async getAgentInfo(id = 0) {
        let res = await axios.post('/api-graphql', {
            query: `{agent(id:${id}){fullName,image}}`
        });

        return res;
    },
    async getCompanyInfo() {
        let {
            data: { logo }
        } = await axios.get('/api-site/place-data', {
            params: {
                fetcher: 'data',
                source: 'logo'
            }
        });
        let {
            data: { company = {} }
        } = await axios.post('/api-graphql', {
            query: `{company{name}}`
        });
        return {
            name: company.name,
            img: logo
        };
    },

    pushStatus(userInfo) {
        if (userInfo) {
            userInfo.t = Date.now();
        }
        return axios.get('/api/chatbot/AI/assistant/lead/push/status', {
            params: userInfo
        });
    },
    // 接口发送成功时触发的服务
    addChat(msg) {
        return axios.get('/api-site/addChat', {
            params: msg
        });
    },
    getQuickReply(pageType, agentId) {
        let url = `/api/chatbot/quick-reply-config/${pageType}`;
        if (agentId) {
            url += `?agentId=${agentId}`;
        }
        return axios.get(url);
    },
    addChatToAgent(msg) {
        return axios.post('/api/chatbot/visit/chat/agent', msg);
    },
    leaveMsg(data) {
        return axios.post('/api-site/leaveMsg', data);
    },
    getChatToken() {
        return axios.post('/api-site/getLeadAccid');
    },
    sendSiteEvent(data) {
        return axios.post('/api/chatbot/visit/chat/site-event', data);
    },
    getVisitorsToken(visitLeadId) {
        return axios.get(
            `/api/chatbot/ai/assistant/visitors/nimtoken?visitId=${visitLeadId}`
        );
    },

    // twilio start
    /**
        获取 twilio 的授权 token
     */
    async getTwilioTokenByAccid(agentAccid, leadAccid) {
        return axios.get(
            `/api/chat/twilio/account?fromIdentity=${agentAccid}&toIdentity=${leadAccid}`
        );
    },
    /**
     * 获取 twilio 的 conversation
     * @param {*} data  {friendlyName:string,fromIdentity:string,toIdentityList:Array<string>, conversationType: 'group_chat'|'single_chat'|'notification',attributes: Map<string,Object> }
     * @returns
     */
    getTwilioConversation(data) {
        return axios.post('/api/chat/twilio/conversation', data);
    }
    // twilio end
};
